/**
 * PB-FND-75 — Text field plugin (registry adapter).
 * Extracted from pb-field-runtime; wired via createTextAdapter(deps).
 */

import { renderStoreTextField } from '@theme/pb-store-field';
import { hasAiTextSettingsSignature } from '@theme/pb-ai-text-logic';

/**
 * @param {object} deps — shared field-runtime helpers
 */
export function createTextAdapter(deps) {
  const {
    fieldTypeLower,
    resolveEsc,
    resolveSelections,
    settingsToString,
    renderControlShell,
    renderImageColumn,
    resolveAdapterSettings,
    validateTextInput,
    escapeHtmlAttr,
  } = deps;

  return {
    id: 'text',
    matches(field) {
      if (hasAiTextSettingsSignature(field)) return false;
      const t = fieldTypeLower(field);
      return t.includes('text') && !t.includes('long') && !t.includes('ai text');
    },
    renderStep(ctx) {
      const field = ctx.field;
      const esc = resolveEsc(ctx);
      const settingsStr = settingsToString(field.settings);
      const existingVal = resolveSelections(ctx)[field.label] || '';
      const markup = renderStoreTextField({ label: field.label || field.question || 'Your answer', value: existingVal });
      const inputHtml = markup.replace('class="store-input"', () => 'class="builder-input" oninput="window.productBuilder.validateText(this)" data-label="' + esc(field.label) + '" data-settings="' + esc(settingsStr) + '" placeholder="Type here..."');
      const visRaw = String(field.visual || '').trim();
      return {
        controlHtml: renderControlShell(field, inputHtml, ctx, { useQuestionHighlight: !visRaw }),
        imageHtml: renderImageColumn(field, ctx),
        stepAttrs: '',
        extraClasses: !visRaw ? 'pb-step-hide-question' : '',
      };
    },
    initStep() {},
    validateStep(stepEl, ctx) {
      const resolved = resolveAdapterSettings(
        stepEl,
        ctx,
        '.builder-input[data-label]',
        'input.builder-input[data-label]'
      );
      if (!resolved) return true;
      return validateTextInput(resolved.el, resolved.settings);
    },
    hydrateStep(stepEl, ctx) {
      const field = ctx.field;
      const val = resolveSelections(ctx)[field.label] || '';
      const input =
        stepEl && stepEl.querySelector('.builder-input[data-label="' + escapeHtmlAttr(field.label) + '"]');
      if (input) input.value = val;
    },
    flushStep(stepEl, ctx) {
      const field = ctx.field;
      const input = stepEl && stepEl.querySelector('.builder-input[data-label]');
      if (!input || !ctx.selections) return;
      ctx.selections[field.label] = input.value;
    },
  };
}
